import { type ErrorResource as BaseErrorResource } from './error';
import { type BaseParams, type HttpStatus, type SimpleQuery } from './requests';

export interface Result {
    ok: boolean;
    headers: Headers;
    status: HttpStatus;
    code?: number;
}

export interface ResultSuccess<T> extends Result {
    ok: true;
    value: T;
}

/**
 * TODO: Remove this when the BE standardaizes response for create account
 *
 * Error comes as an object of arrays rather than as an array
 * {
 *  "error": "Validation error",
 *  "fields": {
 *      "email": [
 *          {
 *              "code": "uniqueness",
 *              "message": "Email must be unique"
 *          }
 *      ]
 *  }
 */

enum ValidationErrorType {
    Email = 'email',
    Password = 'password',
}

export type ValidationField = {
    [key in ValidationErrorType]?: ValidationError[];
};

export interface ValidationError {
    code: string;
    message: string;
}

export type ErrorResponse<T extends BaseErrorResource | string = BaseErrorResource> = T extends BaseErrorResource
    ? BaseErrorResource
    : string;

export interface ResultFail<T = ErrorResponse> extends Result {
    ok: false;
    error: T;
    fields?: ValidationField;
}

export type ApiResult<T, ET = ErrorResponse> = ResultSuccess<T> | ResultFail<ET>;

export type ApiEndpoint<T, P = BaseParams> = (params: P) => Promise<ApiResult<T>>;
export type GqlEndpoint<T, P = SimpleQuery> = (params: P) => Promise<T & { errors?: GraphQLErrorResponse }>;

export interface GraphQLErrorLocation {
    line: number;
    column: number;
}

export interface GraphQLError {
    message: string;
    locations: GraphQLErrorLocation[];
    path: string[];
}

export interface GraphQLErrorResponse {
    response: {
        data: null;
        errors: GraphQLError[];
    };
}
